import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import auth from './modules/auth'
import employee from './modules/employee'

export default createStore({
  modules: {
    auth,
    employee
  },
  plugins: [
    createPersistedState({
      paths: ['auth.token', 'auth.user']
    })
  ]
})
